<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'

const emit = defineEmits<{
  (e: 'save'): void
  (e: 'cancel'): void
}>()

const themeVars = useThemeVars()
</script>

<template>
  <div class="flex items-center gap-2 max-h[36px] p-2 rounded-2 c-table-edit-action-buttons" @click.stop>
    <CIcon class="cursor-pointer" :color="themeVars.primary" icon="check" @click.stop="emit('save')" />
    <CIcon class="cursor-pointer" :color="themeVars.error" icon="xmark" @click.stop="emit('cancel')" />
  </div>
</template>

<style lang="scss">
.c-table-edit-action-buttons {
  border: 1px solid v-bind('themeVars.primary5');
  background: v-bind('themeVars.primary6');
  box-shadow: 0px 6px 8px rgba(41, 51, 92, 0.13);
}
</style>
